import './button.scss';
import {Button} from 'semantic-ui-react';
import {asComponent} from 'components';

export default asComponent(Button);
